import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as English } from './i18n/en';
import { locale as French } from './i18n/fr';
import * as moment from 'moment';
import { SearchCriteria } from 'app/shared/utils/searchCriteria';
import { fuseAnimations } from '@fuse/animations';
enum DatePeriod {
    CurrentMonth = 'CURRENT_MONTH',
    PreviousMonth = 'PREVIOUS_MONTH',
    CurrentYear = 'CURRENT_YEAR',
    PreviousYear = 'PREVIOUS_YEAR',
    FloatingMonth = 'FLOATING_MONTH',
    FloatingYear = 'FLOATING_YEAR'
}
interface PeriodOption {
    value: DatePeriod;
    label: string;
}
@Component({
    selector: 'app-date-range-filter',
    templateUrl: './date-range-filter.component.html',
    styleUrls: ['./date-range-filter.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class DateRangeFilterComponent implements OnInit {
    @Input() fieldName: string;
    @Output() criteriaChange = new EventEmitter<SearchCriteria[]>();
    fromDate: Date;
    toDate: Date;
    selectedPeriod: DatePeriod;
    isFilterActive: boolean = false;
    periods: PeriodOption[] = [
        { value: DatePeriod.CurrentMonth, label: 'DATE_RANGE.CURRENT_MONTH' },
        { value: DatePeriod.PreviousMonth, label: 'DATE_RANGE.PREVIOUS_MONTH' },
        { value: DatePeriod.CurrentYear, label: 'DATE_RANGE.CURRENT_YEAR' },
        { value: DatePeriod.PreviousYear, label: 'DATE_RANGE.PREVIOUS_YEAR' },
        { value: DatePeriod.FloatingMonth, label: 'DATE_RANGE.FLOATING_MONTH' },
        { value: DatePeriod.FloatingYear, label: 'DATE_RANGE.FLOATING_YEAR' }
    ];
    constructor(private _translationLoaderService: FuseTranslationLoaderService) {
        this._translationLoaderService.loadTranslations(English, French);
    }
    ngOnInit(): void {
        this.selectedPeriod = DatePeriod.CurrentMonth;
        this.onPeriodChange(this.selectedPeriod);
    }
    onPeriodChange(period: DatePeriod): void {
        switch (period) {
            case DatePeriod.CurrentMonth:
                this.setCurrentMonth();
                break;
            case DatePeriod.PreviousMonth:
                this.setPreviousMonth();
                break;
            case DatePeriod.CurrentYear:
                this.setCurrentYear();
                break;
            case DatePeriod.PreviousYear:
                this.setPreviousYear();
                break;
            case DatePeriod.FloatingMonth:
                this.setFloatingMonth();
                break;
            case DatePeriod.FloatingYear:
                this.setFloatingYear();
                break;
        }
        this.isFilterActive = true;
        this.emitCriteria();
    }
    onDateChange(): void {
        if (this.fromDate && this.toDate) {
            if (this.fromDate > this.toDate) {
                this.toDate = this.fromDate;
            }
            this.selectedPeriod = null;
            this.isFilterActive = true;
            this.emitCriteria();
        }
    }
    clearFilter(): void {
        this.fromDate = null;
        this.toDate = null;
        this.selectedPeriod = null;
        this.isFilterActive = false;
        this.criteriaChange.emit([]);
    }
    resetFilter(): void {
        this.selectedPeriod = DatePeriod.CurrentMonth;
        this.setCurrentMonth();
        this.isFilterActive = true;
        this.emitCriteria();
    }
    private setCurrentMonth(): void {
        this.fromDate = moment().startOf('month').toDate();
        this.toDate = moment().endOf('month').toDate();
    }
    private setPreviousMonth(): void {
        this.fromDate = moment().subtract(1, 'month').startOf('month').toDate();
        this.toDate = moment().subtract(1, 'month').endOf('month').toDate();
    }
    private setCurrentYear(): void {
        this.fromDate = moment().startOf('year').toDate();
        this.toDate = moment().endOf('year').toDate();
    }
    private setPreviousYear(): void {
        this.fromDate = moment().subtract(1, 'year').startOf('year').toDate();
        this.toDate = moment().subtract(1, 'year').endOf('year').toDate();
    }
    private setFloatingMonth(): void {
        this.fromDate = moment().subtract(30, 'days').toDate();
        this.toDate = moment().toDate();
    }
    private setFloatingYear(): void {
        this.fromDate = moment().subtract(365, 'days').toDate();
        this.toDate = moment().toDate();
    }
    private emitCriteria(): void {
        if (this.fromDate && this.toDate && this.fieldName && this.isFilterActive) {
            const criteria: SearchCriteria[] = [
                new SearchCriteria(this.fieldName, '>=', moment(this.fromDate).format('YYYY-MM-DD')),
                new SearchCriteria(this.fieldName, '<=', moment(this.toDate).format('YYYY-MM-DD'))
            ];
            this.criteriaChange.emit(criteria);
        } else {
            this.criteriaChange.emit([]);
        }
    }
}